import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/download-new.svg'
import _imports_1 from '@/app/ui/assets/svg/bg-dot-pattern-long.svg'
import _imports_2 from '@/app/ui/assets/svg/bg-client-circle-long.svg'
import _imports_3 from '@/app/ui/assets/svg/ics_o_eye_red.svg'


const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "font-normal flex flex-col gap-3" }
const _hoisted_3 = { class: "flex flex-row justify-end" }
const _hoisted_4 = { class: "border border-1 rounded-lg flex flex-col gap-3" }
const _hoisted_5 = {
  class: "px-4 pt-3 pb-2 flex items-center justify-between",
  style: {"border-bottom":"1px solid #E6E6E6"}
}
const _hoisted_6 = { class: "font-semibold text-sm text-black-lp-300" }
const _hoisted_7 = {
  class: "bg-blue-lp-200 rounded-2xl",
  style: {"padding":"2px 8px"}
}
const _hoisted_8 = { class: "text-blue-lp-300" }
const _hoisted_9 = { class: "mx-4 grid grid-cols-2 gap-3" }
const _hoisted_10 = { class: "font-semibold" }
const _hoisted_11 = { class: "font-semibold" }
const _hoisted_12 = { class: "font-semibold" }
const _hoisted_13 = { class: "mx-4 mb-4 bg-gray-lp-1000 rounded-lg p-4 grid grid-cols-2 gap-3" }
const _hoisted_14 = { class: "font-semibold" }
const _hoisted_15 = { class: "font-semibold flex items-center gap-1" }
const _hoisted_16 = { class: "font-semibold" }
const _hoisted_17 = { class: "font-semibold" }
const _hoisted_18 = { class: "font-semibold" }
const _hoisted_19 = {
  class: "flex flex-col px-0 bg-lp-white border border-gray-lp-1300",
  style: {"border-radius":"25px 25px 12px 12px"}
}
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  class: "absolute bottom-0 right-0 opacity-25 size-full",
  src: _imports_1
}, null, -1)
const _hoisted_21 = { class: "flex flex-row space-x-2" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", {
  class: "rounded-md bg-white",
  style: {"min-width":"6px","min-height":"1px"}
}, null, -1)
const _hoisted_23 = { class: "flex-grow text-xl text-left content-center text-white pr-8 font-semibold" }
const _hoisted_24 = {
  key: 0,
  class: "px-10 rounded-2xl content-center font-bold",
  style: 
            `max-height: 28px; min-height: 28px; color: #B82025; background-color: #F8E9E9;`
          
}
const _hoisted_25 = {
  key: 1,
  class: "flex items-center gap-2"
}
const _hoisted_26 = { class: "font-bold" }
const _hoisted_27 = {
  key: 0,
  class: "px-3 rounded-2xl content-center text-base h-7 bg-blue-100 text-blue-500 font-bold",
  "data-testid": "info-price-client-current-rate-partially"
}
const _hoisted_28 = { class: "flex flex-col px-6 py-3 gap-y-2" }
const _hoisted_29 = {
  key: 1,
  class: "flex flex-row items-center gap-2 w-full"
}
const _hoisted_30 = { class: "w-full flex justify-between p-3 items-center rounded-md bg-gray-lp-1500 font-semibold content-center" }
const _hoisted_31 = { class: "flex flex-row gap-x-1 items-center" }
const _hoisted_32 = { class: "content-center" }
const _hoisted_33 = { class: "flex flex-end" }
const _hoisted_34 = { class: "flex flex-row items-center gap-2 w-full" }
const _hoisted_35 = { class: "w-full flex flex-row gap-x-1 p-3 items-center rounded-md bg-gray-lp-1500 font-semibold content-center" }
const _hoisted_36 = { class: "content-center" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 0,
  class: "w-full"
}
const _hoisted_39 = { key: 1 }
const _hoisted_40 = {
  key: 0,
  class: "flex"
}
const _hoisted_41 = { class: "flex flex-row gap-x-2" }
const _hoisted_42 = {
  key: 0,
  class: "relative flex flex-grow flex-row gap-x-2 p-2 rounded-xl bg-gray-lp-1200 overflow-hidden"
}
const _hoisted_43 = { class: "flex-grow content-center" }
const _hoisted_44 = { class: "font-semibold" }
const _hoisted_45 = { class: "text-gray-lp-800" }
const _hoisted_46 = { class: "flex flex-row gap-x-1 p-2 bg-purple-lp-100 rounded-xl z-10" }
const _hoisted_47 = { class: "text-gray-lp-600 text-xs" }
const _hoisted_48 = { class: "text-xs font-semibold text-gray-lp-300" }
const _hoisted_49 = /*#__PURE__*/_createVNode("img", {
  class: "absolute top-0 bottom-0 right-0 h-full",
  src: _imports_2
}, null, -1)
const _hoisted_50 = {
  key: 1,
  class: "flex"
}
const _hoisted_51 = {
  key: 2,
  class: "flex"
}
const _hoisted_52 = {
  key: 3,
  class: "flex"
}
const _hoisted_53 = {
  key: 0,
  class: "w-full flex flex-row border border-gray-lp-1300 rounded-xl px-6 py-3 items-center"
}
const _hoisted_54 = { class: "w-full flex flex-row gap-x-2" }
const _hoisted_55 = { class: "flex-shrink-0 font-semibold text-20px text-black self-center" }
const _hoisted_56 = /*#__PURE__*/_createVNode("div", { class: "border-r border-gray-lp-200" }, null, -1)
const _hoisted_57 = { class: "w-full flex flex-row gap-x-1" }
const _hoisted_58 = { class: "font-semibold text-14px text-gray-lp-600 self-center" }
const _hoisted_59 = /*#__PURE__*/_createVNode("hr", { style: {"border-top":"1px solid #ebecf0"} }, null, -1)
const _hoisted_60 = { class: "p-6" }
const _hoisted_61 = { class: "grid grid-cols-3 gap-4 text-sm" }
const _hoisted_62 = { class: "flex flex-col pt-2" }
const _hoisted_63 = { class: "flex flex-row gap-2 items-center" }
const _hoisted_64 = /*#__PURE__*/_createVNode("div", { class: "w-2.5 h-2.5 rounded-full bg-gray-lp-600" }, null, -1)
const _hoisted_65 = { class: "text-sm font-semibold text-gray-lp-300" }
const _hoisted_66 = { class: "flex flex-row items-center gap-2 pl-1" }
const _hoisted_67 = {
  "data-testid": "info-price-client-start-date",
  class: "text-sm text-gray-lp-600 border-l border-gray-lp-1300 border-dashed pl-3",
  style: {"padding-top":"4px","padding-bottom":"8px"}
}
const _hoisted_68 = { class: "flex flex-row gap-2 items-center" }
const _hoisted_69 = /*#__PURE__*/_createVNode("div", { class: "w-2.5 h-2.5 rounded-full bg-gray-lp-600" }, null, -1)
const _hoisted_70 = { class: "text-sm font-semibold text-gray-lp-300" }
const _hoisted_71 = {
  class: "flex flex-row items-center gap-2",
  style: {"padding-left":"18px"}
}
const _hoisted_72 = {
  "data-testid": "info-price-client-end-date",
  class: "text-sm text-gray-lp-600",
  style: {"padding-top":"4px"}
}
const _hoisted_73 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_74 = {
  key: 1,
  class: "flex flex-row gap-x-2"
}
const _hoisted_75 = {
  key: 2,
  class: "text-sm my-1"
}
const _hoisted_76 = {
  key: 0,
  class: "text-sm text-gray-lp-300"
}
const _hoisted_77 = { class: "text-red-lp-300 font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ModalChangeInsurance = _resolveComponent("ModalChangeInsurance")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_PriceTypeForm = _resolveComponent("PriceTypeForm")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!
  const _component_ModalDiskon = _resolveComponent("ModalDiskon")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_ConfirmationApprovalUpdateRates = _resolveComponent("ConfirmationApprovalUpdateRates")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_WidgetBulkDownloadClient = _resolveComponent("WidgetBulkDownloadClient")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      title: _ctx.$t('clientManagement.infoPriceClient.origin3lc'),
      modelValue: _ctx.modelDialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelDialog = $event)),
      showOverflow: "",
      customHeight: "300px"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.lcOptions, (origin, index) => {
              return (_openBlock(), _createBlock("div", {
                key: index,
                style: {"min-width":"500px"}
              }, [
                _createVNode("div", null, _toDisplayString(origin), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _withDirectives(_createVNode(_component_ModalChangeInsurance, {
      modelValue: _ctx.form,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form = $event)),
      clientId: _ctx.detailData.id,
      clientName: _ctx.detailData.clientName,
      error: _ctx.error,
      onOnClosePopup: _ctx.closeChangeInsurance,
      onOnSuccessEdit: _ctx.getDetailClientRegistrationV2
    }, null, 8, ["modelValue", "clientId", "clientName", "error", "onOnClosePopup", "onOnSuccessEdit"]), [
      [_vShow, _ctx.isUpdateInsurance]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.confirmUpdateRateConfirmation,
      onClose: _ctx.closeUpdateRateConfirmation,
      title: _ctx.$t('clientManagement.infoPriceClient.changeParentClientPriceQuestion'),
      message: _ctx.$t('clientManagement.infoPriceClient.changeParentClientPriceMessage'),
      image: "badge-confirmation-general",
      textSuccess: _ctx.$t('clientManagement.infoPriceClient.yesChange'),
      textCancel: _ctx.$t('clientManagement.infoPriceClient.back'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.isUpdateRateConfirmation]
    ]),
    (_ctx.updateRateDialog)
      ? (_openBlock(), _createBlock(_component_ModalV2, {
          key: 0,
          width: "w-10/12",
          title: _ctx.$t('clientManagement.infoPriceClient.changeParentClientPrice'),
          showFooter: true,
          onClose: 
      () => {
        _ctx.updateRateDialog = false;
        _ctx.onResetForm();
      }
    
        }, {
          content: _withCtx(() => [
            _createVNode(_component_PriceTypeForm, {
              modelValue: _ctx.form,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form = $event)),
              error: _ctx.error,
              "onUpdate:error": _cache[4] || (_cache[4] = ($event: any) => (_ctx.error = $event)),
              customPriceOption: _ctx.customPriceOption
            }, null, 8, ["modelValue", "error", "customPriceOption"])
          ]),
          footer: _withCtx(() => [
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_LpButton, {
                title: _ctx.$t('clientManagement.infoPriceClient.save'),
                textColor: "white",
                disabled: !_ctx.isValidUpdateRate,
                onClick: _ctx.submitUpdateRate
              }, null, 8, ["title", "disabled", "onClick"])
            ])
          ]),
          _: 1
        }, 8, ["title", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalDiskon, {
      modelValue: _ctx.isVisibleModalDiskon,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isVisibleModalDiskon = $event)),
      data: _ctx.dataDiscount
    }, null, 8, ["modelValue", "data"]),
    (_ctx.updatePrice)
      ? (_openBlock(), _createBlock(_component_ModalV2, {
          key: 1,
          width: "w-5/12",
          title: _ctx.$t('clientManagement.infoPriceClient.priceChange'),
          showFooter: false,
          onClose: 
      () => {
        _ctx.updatePrice = false;
      }
    
        }, {
          content: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", null, [
                  _createVNode("span", _hoisted_6, _toDisplayString(_ctx.formattedDate(_ctx.detailClientLiveRate.clientRateCreatedAt)), 1)
                ]),
                _createVNode("div", _hoisted_7, [
                  _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.renew")), 1)
                ])
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode("div", null, [
                  _createVNode("label", null, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.submittedBy")), 1),
                  _createVNode("div", _hoisted_10, _toDisplayString(_ctx.detailClientLiveRate.clientRateCreatedBy || "-"), 1)
                ]),
                _createVNode("div", null, [
                  _createVNode("label", null, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.submissionDate")), 1),
                  _createVNode("div", _hoisted_11, _toDisplayString(_ctx.formatDate(_ctx.detailClientLiveRate.clientRateCreatedAt)), 1)
                ]),
                _createVNode("div", null, [
                  _createVNode("label", null, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.activeDate")), 1),
                  _createVNode("div", _hoisted_12, _toDisplayString(_ctx.formatDate(_ctx.detailClientLiveRate.clientRateActiveDate)), 1)
                ])
              ]),
              _createVNode("div", _hoisted_13, [
                _createVNode("div", null, [
                  _createVNode("label", null, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.customPriceType")), 1),
                  _createVNode("div", _hoisted_14, _toDisplayString(_ctx.customPriceRate), 1)
                ]),
                _createVNode("div", null, [
                  _createVNode("label", null, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.price")), 1),
                  _createVNode("div", _hoisted_15, [
                    _createTextVNode(_toDisplayString(_ctx.detailClientLiveRate.clientFileNameCustomRate ? _ctx.elipsisText(_ctx.detailClientLiveRate.clientFileNameCustomRate) : "-") + " ", 1),
                    (_ctx.detailClientLiveRate.clientFileCustomRate)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          class: "w-4 h-4",
                          src: _imports_0,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.downloadExcel(_ctx.detailClientLiveRate.clientFileCustomRate)))
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", null, [
                  _createVNode("label", null, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.insurance")), 1),
                  _createVNode("div", _hoisted_16, _toDisplayString(_ctx.detailClientLiveRate.clientRateInsuranceType) + " " + _toDisplayString(_ctx.detailClientLiveRate.clientRateInsuranceValuePercentage) + "% ", 1)
                ]),
                _createVNode("div", null, [
                  _createVNode("label", null, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.discount")), 1),
                  _createVNode("div", _hoisted_17, _toDisplayString(_ctx.detailClientLiveRate.clientDiscountBaseRate) + "% ", 1)
                ]),
                _createVNode("div", null, [
                  _createVNode("label", null, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.origin3lc")), 1),
                  _createVNode("div", _hoisted_18, _toDisplayString(_ctx.detailClientLiveRate.clientRateVersionCustom3lc ? _ctx.detailClientLiveRate.clientRateVersionCustom3lc : _ctx.$t("clientManagement.infoPriceClient.all3lcs")), 1)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["title", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_19, [
      _createVNode("div", {
        class: "relative flex flex-col py-8 px-6 overflow-hidden",
        style: `border-radius: 25px; background-color: ${_ctx.bannerColor};`
      }, [
        _hoisted_20,
        _createVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode(_component_Icons, { name: "icon-money-fill" }),
          _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.currentPrice")), 1),
          (_ctx.isClientFreeze)
            ? (_openBlock(), _createBlock("div", _hoisted_24, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.freeze")), 1))
            : (_openBlock(), _createBlock("div", _hoisted_25, [
                _createVNode("div", {
                  class: "px-3 rounded-2xl content-center text-base",
                  "data-testid": 'info-price-client-current-rate-status',
                  style: 
              `max-height: 28px; min-height: 28px; color: ${_ctx.statusTextColor}; background-color: ${_ctx.statusBgColor};`
            
                }, [
                  _createVNode("span", _hoisted_26, _toDisplayString(_ctx.statusString), 1)
                ], 4),
                (_ctx.isPartially)
                  ? (_openBlock(), _createBlock("div", _hoisted_27, _toDisplayString(_ctx.partiallyLabel), 1))
                  : _createCommentVNode("", true)
              ]))
        ])
      ], 4),
      _createVNode("div", _hoisted_28, [
        _createVNode("div", {
          class: ["flex gap-y-2", 
          _ctx.clientStatus === 'waiting' || _ctx.clientStatus === 'requested'
            ? 'flex-row gap-6 justify-between'
            : 'flex-col'
        ]
        }, [
          (_ctx.isRequestedApproval)
            ? (_openBlock(), _createBlock(_component_ConfirmationApprovalUpdateRates, {
                key: 0,
                approvalType: "renewal",
                clientType: _ctx.isParent ? _ctx.$t('clientManagement.managementList.parentClient').toString().toLowerCase() : _ctx.$t('clientManagement.managementList.branchClient').toString().toLowerCase(),
                id: _ctx.detailData.clientLiveRate.clientCustomRateId,
                clientName: _ctx.detailData.clientName,
                errorMessage: _ctx.errorMessage,
                onSuccessReject: _ctx.fetchDetail,
                onSuccessApprove: _ctx.fetchDetail
              }, null, 8, ["clientType", "id", "clientName", "errorMessage", "onSuccessReject", "onSuccessApprove"]))
            : _createCommentVNode("", true),
          (_ctx.isClientLiveRate)
            ? (_openBlock(), _createBlock("div", _hoisted_29, [
                _createVNode("div", _hoisted_30, [
                  _createVNode("div", _hoisted_31, [
                    _createVNode("div", _hoisted_32, [
                      _createVNode(_component_Icons, {
                        name: `${_ctx.mapStatusRate.icon}`,
                        color: `${_ctx.mapStatusRate.iconColor}`,
                        width: "25px",
                        height: "25px"
                      }, null, 8, ["name", "color"])
                    ]),
                    _createVNode("div", null, _toDisplayString(_ctx.mapStatusRate.title), 1)
                  ]),
                  _createVNode("div", _hoisted_33, [
                    _createVNode("span", {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changePrice())),
                      class: `font-semibold ${_ctx.mapStatusRate.classStatusRate} py-1 px-3 rounded-full`
                    }, _toDisplayString(_ctx.mapStatusRate.btnStatusRate), 3)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_34, [
            _createVNode("div", _hoisted_35, [
              _createVNode("div", _hoisted_36, [
                (_ctx.clientStatus === 'requested' || _ctx.clientStatus === 'waiting')
                  ? (_openBlock(), _createBlock(_component_Icons, {
                      key: 0,
                      name: "warning-circle-fill"
                    }))
                  : (!!_ctx.rejectReasonMessage && _ctx.rejectReasonMessage !== '-')
                    ? (_openBlock(), _createBlock(_component_Icons, {
                        key: 1,
                        name: "x-circle"
                      }))
                    : (_openBlock(), _createBlock(_component_Icons, {
                        key: 2,
                        name: "check-green-fill"
                      }))
              ]),
              (!!_ctx.rejectReasonMessage && _ctx.rejectReasonMessage !== '-')
                ? (_openBlock(), _createBlock("div", _hoisted_37, _toDisplayString(_ctx.rejectReasonMessage || "-"), 1))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    (_ctx.clientStatus === 'waiting' || _ctx.clientStatus === 'requested')
                      ? (_openBlock(), _createBlock("div", _hoisted_38, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.ensurePriceInfo")), 1))
                      : (_openBlock(), _createBlock("div", _hoisted_39, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.clientRequestAccepted")), 1))
                  ], 64))
            ]),
            (_ctx.isErrorFile)
              ? (_openBlock(), _createBlock("div", _hoisted_40, [
                  (_ctx.canShowBtnAttachment)
                    ? (_openBlock(), _createBlock(_component_lp_button, {
                        key: 0,
                        onClick: _ctx.downloadErrorFile,
                        customClass: "h-full",
                        title: _ctx.$t('clientManagement.infoPriceClient.downloadFailedFile'),
                        iconLeft: "download-new",
                        iconColor: "red-lp-300",
                        textColor: "red-lp-300",
                        color: "red-lp-300",
                        outline: ""
                      }, null, 8, ["onClick", "title"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_41, [
            (_ctx.clientStatus !== 'waiting' && _ctx.clientStatus !== 'requested')
              ? (_openBlock(), _createBlock("div", _hoisted_42, [
                  _createVNode("div", _hoisted_43, [
                    _createVNode("span", _hoisted_44, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.date")) + " " + _toDisplayString(_ctx.isRejected ? _ctx.$t("clientManagement.infoPriceClient.rejected")  : _ctx.isCancelled ? _ctx.$t("clientManagement.infoPriceClient.cancelled") : _ctx.$t("clientManagement.infoPriceClient.accepted")) + ": ", 1),
                    _createVNode("span", _hoisted_45, _toDisplayString(_ctx.clientStatusUpdatedAt), 1)
                  ]),
                  _createVNode("div", _hoisted_46, [
                    _createVNode("span", _hoisted_47, _toDisplayString(_ctx.isRejected ? _ctx.$t("clientManagement.infoPriceClient.rejected") : _ctx.isCancelled ?  _ctx.$t("clientManagement.infoPriceClient.cancelled") : _ctx.$t("clientManagement.infoPriceClient.accepted")) + " " + _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.by")), 1),
                    _createVNode(_component_Icons, {
                      name: "icon-profile-fill",
                      style: {"width":"16px","height":"16px"}
                    }),
                    _createVNode("span", _hoisted_48, _toDisplayString(_ctx.clientCurrentRate?.clientStatusUpdatedBy || "-"), 1)
                  ]),
                  _hoisted_49
                ]))
              : _createCommentVNode("", true),
            (_ctx.showButtonChangeInsurance)
              ? (_openBlock(), _createBlock("div", _hoisted_50, [
                  _createVNode(_component_lp_button, {
                    onClick: _ctx.changeInsurance,
                    customClass: "h-full",
                    title: "Ubah Asuransi",
                    textColor: "white",
                    color: "red-lp-300",
                    small: ""
                  }, null, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showUbahHargaButton)
              ? (_openBlock(), _createBlock("div", _hoisted_51, [
                  _createVNode(_component_lp_button, {
                    onClick: _ctx.updateRate,
                    customClass: "h-full",
                    title: _ctx.$t('clientManagement.infoPriceClient.changePrice'),
                    textColor: "white",
                    color: "red-lp-300",
                    small: ""
                  }, null, 8, ["onClick", "title"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isShowDownloadButton)
              ? (_openBlock(), _createBlock("div", _hoisted_52, [
                  _createVNode(_component_lp_button, {
                    "data-testid": "info-price-client-download-attachment-bg",
                    onClick: _ctx.downloadAttachmentBackground,
                    customClass: "h-full",
                    title: _ctx.$t('clientManagement.infoPriceClient.downloadAttachmentFile'),
                    iconLeft: "download-new",
                    iconColor: "red-lp-300",
                    textColor: "red-lp-300",
                    color: "red-lp-300",
                    outline: "",
                    small: ""
                  }, null, 8, ["onClick", "title"])
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2),
        (
          _ctx.detailData.clientCurrentRate?.clientStatusCustomRate ===
            'uploading' &&
            (_ctx.isCancelUploadRate || _ctx.ratesRetryUploadConfig)
        )
          ? (_openBlock(), _createBlock("div", _hoisted_53, [
              _createVNode("div", _hoisted_54, [
                _createVNode("div", _hoisted_55, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.updatePrice")), 1),
                _hoisted_56,
                _createVNode("div", _hoisted_57, [
                  _createVNode(_component_Icons, {
                    name: "reload",
                    class: "w-5 text-gray-lp-600"
                  }),
                  _createVNode("div", _hoisted_58, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.lastProcessed", { date: _ctx.rateVersionUpdatedAt })), 1)
                ])
              ]),
              (_ctx.isCancelUploadRate)
                ? (_openBlock(), _createBlock(_component_LpButton, {
                    key: 0,
                    class: "ml-4",
                    customClass: "h-full",
                    title: _ctx.$t('clientManagement.infoPriceClient.cancelProcess'),
                    textColor: "red-lp-300",
                    color: "red-lp-300",
                    outline: "",
                    small: "",
                    onClick: _ctx.onConfirmCancelProcessUploadRate
                  }, null, 8, ["title", "onClick"]))
                : _createCommentVNode("", true),
              (_ctx.ratesRetryUploadConfig)
                ? (_openBlock(), _createBlock(_component_lp_button, {
                    key: 1,
                    class: "ml-4",
                    onClick: _ctx.onOpenRetryConfirmationUploadRate,
                    title: _ctx.$t('clientManagement.infoPriceClient.retry'),
                    textColor: "white",
                    color: "red-lp-300",
                    disabled: _ctx.validationRetryButton
                  }, null, 8, ["onClick", "title", "disabled"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_59,
      _createVNode("div", _hoisted_60, [
        _createVNode("div", _hoisted_61, [
          _createVNode(_component_DataWrapper, {
            fontSize: 14,
            label: _ctx.$t('clientManagement.infoPriceClient.pricePeriod'),
            value: _ctx.periodeHarga,
            customStyleValue: "text-sm my-1 break-words"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_62, [
                _createVNode("div", _hoisted_63, [
                  _hoisted_64,
                  _createVNode("div", _hoisted_65, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.start')), 1)
                ]),
                _createVNode("div", _hoisted_66, [
                  _createVNode("div", _hoisted_67, _toDisplayString(_ctx.periodeHarga.start), 1)
                ]),
                _createVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _createVNode("div", _hoisted_70, _toDisplayString(_ctx.$t('clientManagement.infoPriceClient.end')), 1)
                ]),
                _createVNode("div", _hoisted_71, [
                  _createVNode("div", _hoisted_72, _toDisplayString(_ctx.periodeHarga.end), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["label", "value"]),
          _createVNode(_component_DataWrapper, {
            fontSize: 14,
            label: _ctx.$t('clientManagement.infoPriceClient.customPriceType'),
            value: _ctx.tipeKostumisasiHarga,
            customStyleValue: "text-sm my-1 break-words"
          }, null, 8, ["label", "value"]),
          _createVNode(_component_DataWrapper, {
            fontSize: 14,
            label: _ctx.$t('clientManagement.infoPriceClient.specialPrice'),
            value: _ctx.hargaKhusus,
            customStyleValue: "text-sm my-1 break-words"
          }, null, 8, ["label", "value"]),
          _createVNode(_component_DataWrapper, {
            fontSize: 14,
            label: _ctx.$t('clientManagement.infoPriceClient.price'),
            value: _ctx.detailData.clientCurrentRate.clientVersionBaseRate,
            customStyleValue: "text-sm my-1 break-words"
          }, null, 8, ["label", "value"]),
          _createVNode(_component_DataWrapper, {
            fontSize: 14,
            label: _ctx.$t('clientManagement.infoPriceClient.weightCalculation'),
            value: _ctx.$t('clientManagement.infoPriceClient.chargeableWeight'),
            customStyleValue: "text-sm my-1 break-words"
          }, null, 8, ["label", "value"]),
          _createVNode(_component_DataWrapper, {
            fontSize: 14,
            label: _ctx.$t('clientManagement.infoPriceClient.insuranceCalculation'),
            value: _ctx.perhitunganAsuransi,
            customStyleValue: "text-sm my-1 break-words"
          }, null, 8, ["label", "value"]),
          _createVNode(_component_DataWrapper, {
            fontSize: 14,
            label: _ctx.$t('clientManagement.infoPriceClient.origin3lc'),
            customStyleValue: "text-sm my-1 break-words"
          }, {
            default: _withCtx(() => [
              (_ctx.isPriceTypeCustom)
                ? (_openBlock(), _createBlock("div", _hoisted_73, " - "))
                : (_ctx.lcOptions.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_74, [
                      _createVNode("div", null, _toDisplayString(_ctx.lcOptions.length), 1),
                      _createVNode("div", null, [
                        _createVNode(_component_lp_button, {
                          title: _ctx.$t('clientManagement.infoPriceClient.seeAll'),
                          flat: "",
                          compact: "",
                          customClass: "text-red-lp-100",
                          iconLeft: "eye",
                          iconV2: true,
                          sizeIcon: "15px",
                          color: "transparent",
                          textSize: 5,
                          onClick: _ctx.showAll
                        }, null, 8, ["title", "onClick"])
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_75, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.all3lcs")), 1))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            fontSize: 14,
            label: _ctx.$t('clientManagement.infoPriceClient.discount'),
            customStyleValue: "text-sm my-1 break-words"
          }, {
            default: _withCtx(() => [
              (_ctx.allDiscount)
                ? (_openBlock(), _createBlock("div", _hoisted_76, _toDisplayString(_ctx.allDiscountValue) + "% ", 1))
                : (_openBlock(), _createBlock("div", {
                    key: 1,
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openModalDsikon && _ctx.openModalDsikon(...args))),
                    class: "flex flex-row items-center space-x-1 cursor-pointer"
                  }, [
                    _createVNode("img", {
                      src: _imports_3,
                      alt: _ctx.$t('clientManagement.infoPriceClient.seeDiscount'),
                      class: "w-5 inline-block"
                    }, null, 8, ["alt"]),
                    _createVNode("span", _hoisted_77, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.seeDiscount")), 1)
                  ]))
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ])
    ]),
    (_ctx.canShowBtnDownloadNew)
      ? (_openBlock(), _createBlock(_component_WidgetBulkDownloadClient, {
          key: 2,
          clientId: _ctx.detailData.id || _ctx.id,
          type: "client_rate"
        }, null, 8, ["clientId"]))
      : _createCommentVNode("", true)
  ], 64))
}